module.exports = __webpack_public_path__ + "static/media/inf_76og77.ffa79e9b.mp3";